import React from 'react';
import { ADJUSTMENT_YEARS } from './forecastAdjustments';
import {
  forecastImpactCellDelta,
  formatForecastImpactDelta
} from './forecastImpact';

const ForecastImpactPreviewTable = ({
  diffLines = [],
  years = ADJUSTMENT_YEARS,
  classifyLine = () => 'flow',
  drivenByField = {},
  emptyMessage = 'No material line movement at the proposed values.',
  showBasisNote = true
}) => (
  <div className="forecast-prompt-effects">
    <div className="forecast-prompt-subhead">
      Projected effect ($MM) · annual{' '}
      <span className="forecast-prompt-legend">
        <em className="dot primary" /> primary
        <em className="dot driven" /> driver-linked
        <em className="dot flow" /> flows through
      </span>
    </div>
    {diffLines.length === 0 && (
      <p className="forecast-submit-note">{emptyMessage}</p>
    )}
    {diffLines.length > 0 && (
      <table className="forecast-prompt-effect-table">
        <thead>
          <tr>
            <th>Line</th>
            {years.map((year) => <th key={year}>FY{year} Δ</th>)}
            <th>5-yr Δ</th>
          </tr>
        </thead>
        <tbody>
          {diffLines.map((line) => {
            const kind = classifyLine(line);
            const driver = drivenByField[line.field];
            const finalYear = years[years.length - 1];
            const finalYearDelta = forecastImpactCellDelta(line, finalYear);
            return (
              <tr key={line.field} className={`effect-${kind}`}>
                <td>
                  <span className={`dot ${kind}`} />
                  {line.label}
                  {kind === 'driven' && driver && (
                    <em className="ai-driver-link" title={driver.why}> ↳ {driver.driverName}</em>
                  )}
                  {line.measure === 'EOP' && <small className="forecast-prompt-measure"> · point-in-time</small>}
                </td>
                {years.map((year) => {
                  const delta = forecastImpactCellDelta(line, year);
                  return (
                    <td key={year} className={delta > 0 ? 'pos' : delta < 0 ? 'neg' : ''}>
                      {formatForecastImpactDelta(delta)}
                    </td>
                  );
                })}
                <td className={line.totalDelta > 0 ? 'pos' : line.totalDelta < 0 ? 'neg' : ''}>
                  <strong>
                    {formatForecastImpactDelta(line.measure === 'EOP' ? finalYearDelta : line.totalDelta)}
                  </strong>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    )}
    {showBasisNote && (
      <p className="forecast-basis-note">
        Balance lines (EOP) are point-in-time and never summed across months; income/expense lines accumulate.
        Figures are computed by the model, not the AI.
      </p>
    )}
  </div>
);

export default ForecastImpactPreviewTable;
